export class RemoveSharedUserRequest{
    planogramId: string = '';
    targetUserId: string = '';
    constructor(planogramId: string, targetUserId: string){
        this.planogramId = planogramId;
        this.targetUserId = targetUserId;
    }
}

